import { useMenuDropdown } from '@shared/ui';
import { DropdownItem, DropdownMenuWithButton } from '@shared/ui/menus/dropdown-menu';

export const EventTicketMenu = (): JSX.Element => {
  const { menuRef, onClose, handleToggleDropdown, isMenuOpen } = useMenuDropdown({});

  return (
    <DropdownMenuWithButton
      isMenuOpen={isMenuOpen}
      onMenuBtnClick={handleToggleDropdown}
      menuRef={menuRef}
    >
      <DropdownItem>Отказ от участия</DropdownItem>
    </DropdownMenuWithButton>
  );
};
